import React from 'react'
import { Link } from 'react-scroll'
import { useIntl } from 'react-intl'

export default function useHowItWorks() {
  const intl = useIntl()

  const howItWorksForEmployees = [
    {
      id: 1,
      title:
        intl.messages[
          'smb_acquisition_home.how_it_works.benefits.company.benefit_1.title'
        ],
      description: intl.formatMessage(
        {
          id:
            'smb_acquisition_home.how_it_works.benefits.company.benefit_1.subtitle',
        },
        {
          a: (...chunks) => (
            <Link to="company-plans" duration={1000} spy smooth>
              {chunks}
            </Link>
          ),
        }
      ),
    },
    {
      id: 2,
      title:
        intl.messages[
          'smb_acquisition_home.how_it_works.benefits.company.benefit_2.title'
        ],
      description: intl.formatMessage(
        {
          id:
            'smb_acquisition_home.how_it_works.benefits.company.benefit_2.subtitle',
        },
        {
          a: (...chunks) => (
            <a
              href="https://promo.gympass.com/wp-content/uploads/2020/06/US_Employee_membership_fee_v2-1.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              {chunks}
            </a>
          ),
        }
      ),
    },
    {
      id: 3,
      title:
        intl.messages[
          'smb_acquisition_home.how_it_works.benefits.company.benefit_3.title'
        ],
      description:
        intl.messages[
          'smb_acquisition_home.how_it_works.benefits.company.benefit_3.subtitle'
        ],
    },
  ]

  return {
    howItWorksForEmployees,
  }
}
